export interface ScenarioChapterDef {
    index: number;
    startWeek: number;
    endWeek: number;
    title: string;
    subtitle?: string;
    tone?: "steel" | "brass" | "ember" | "burgundy";
}

export interface ScenarioBookendDef {
    index: number;
    endWeek: number;
    closingLine: string;
    nextTeaser?: string | null;
}

const SCENARIO_CHAPTERS: Record<string, ScenarioChapterDef[]> = {
    "frontier-vanguard": [
        {
            index: 0,
            startWeek: 1,
            endWeek: 20,
            title: "원정 준비기",
            subtitle: "아직 아무도 잃지 않았기에 더 조용한 시기. 장비와 이름, 첫 임무의 순서를 정하며 원정의 숨을 맞춘다.",
            tone: "steel",
        },
        {
            index: 1,
            startWeek: 21,
            endWeek: 48,
            title: "행군기",
            subtitle: "길은 지도보다 길고, 전투는 승패보다 피로를 남긴다. 전진할수록 귀환은 더 값비싼 일이 된다.",
            tone: "brass",
        },
        {
            index: 2,
            startWeek: 49,
            endWeek: 72,
            title: "거점 확보기",
            subtitle: "전진만으로는 버틸 수 없는 구간. 벽과 장부와 주민의 시선을 동시에 붙들어 둘 자리가 필요해진다.",
            tone: "ember",
        },
        {
            index: 3,
            startWeek: 73,
            endWeek: 96,
            title: "최종 결착기",
            subtitle: "지금까지의 약속과 손실이 한 장부 위에 모인다. 정복과 화의, 그리고 어떤 이름으로 돌아갈지 여기서 남는다.",
            tone: "burgundy",
        },
    ],
    "arena-crown": [
        {
            index: 0,
            startWeek: 1,
            endWeek: 24,
            title: "입장기",
            subtitle: "처음으로 모래 위에 이름을 올리고, 투기장이 사람을 어떻게 기억하는지 배우는 시기.",
            tone: "steel",
        },
        {
            index: 1,
            startWeek: 25,
            endWeek: 48,
            title: "예선기",
            subtitle: "승리 하나하나가 평판과 후원을 끌어당기기 시작한다. 칼보다 시선이 더 무거워지는 구간.",
            tone: "brass",
        },
        {
            index: 2,
            startWeek: 49,
            endWeek: 72,
            title: "준결승기",
            subtitle: "승패보다 자세와 명예가 더 날카롭게 기록된다. 한 번의 흔들림도 곧 가문의 얼굴이 된다.",
            tone: "ember",
        },
        {
            index: 3,
            startWeek: 73,
            endWeek: 96,
            title: "왕관전",
            subtitle: "남는 것은 승자 명단 한 줄이 아니라, 끝까지 어떤 이름으로 섰는가 하는 기억이다.",
            tone: "burgundy",
        },
    ],
    "magitower-summit": [
        {
            index: 0,
            startWeek: 1,
            endWeek: 24,
            title: "개회 회랑",
            subtitle: "연구실과 연구실 사이를 오가며, 누가 먼저 말하고 누가 침묵하는지가 권력이 되는 계절의 시작.",
            tone: "steel",
        },
        {
            index: 1,
            startWeek: 25,
            endWeek: 48,
            title: "봉인 서고기",
            subtitle: "지식을 얻을수록 무엇을 잃는지도 선명해진다. 기록과 금기가 한 문장 안에 겹치는 시기.",
            tone: "brass",
        },
        {
            index: 2,
            startWeek: 49,
            endWeek: 72,
            title: "표결기",
            subtitle: "정답보다 편과 명분이 더 크게 작용한다. 문장은 여전히 중요하지만, 누구 편의 문장인가가 더 중요해진다.",
            tone: "ember",
        },
        {
            index: 3,
            startWeek: 73,
            endWeek: 96,
            title: "최종안",
            subtitle: "이제 남는 것은 연구 결과가 아니라, 끝내 어떤 지식을 자신의 이름으로 남길 것인가 하는 결단이다.",
            tone: "burgundy",
        },
    ],
    "skyrail-grandprix": [
        {
            index: 0,
            startWeek: 1,
            endWeek: 24,
            title: "면허기",
            subtitle: "기체를 다루는 손과 공포를 견디는 숨을 함께 익히는 구간. 하늘 철로의 첫 박자가 몸에 밴다.",
            tone: "steel",
        },
        {
            index: 1,
            startWeek: 25,
            endWeek: 48,
            title: "예선 리그",
            subtitle: "속도는 기록으로 남고, 흔들림은 곧 순위로 돌아온다. 한 번의 오차가 모두의 시선을 끌기 시작한다.",
            tone: "brass",
        },
        {
            index: 2,
            startWeek: 49,
            endWeek: 72,
            title: "정비와 추월",
            subtitle: "이제 승부는 조종만으로 나지 않는다. 기체를 살리고 팀을 버티게 하는 손까지 함께 시험대에 오른다.",
            tone: "ember",
        },
        {
            index: 3,
            startWeek: 73,
            endWeek: 96,
            title: "그랑프리 결선",
            subtitle: "가장 빠른 자와 끝까지 남는 자가 같은 이름일지, 다른 이름일지 마지막으로 갈라지는 구간.",
            tone: "burgundy",
        },
    ],
    "sunken-cathedral": [
        {
            index: 0,
            startWeek: 1,
            endWeek: 24,
            title: "조수의 문턱",
            subtitle: "물 아래에서 돌아오는 오래된 기도와 처음 마주하는 시기. 구원과 금단의 경계가 아직 희미하다.",
            tone: "steel",
        },
        {
            index: 1,
            startWeek: 25,
            endWeek: 48,
            title: "침수 회랑",
            subtitle: "깊이 들어갈수록 성당은 장소가 아니라 기억처럼 느껴진다. 누가 무엇을 깨우고 있는지 점점 불분명해진다.",
            tone: "brass",
        },
        {
            index: 2,
            startWeek: 49,
            endWeek: 72,
            title: "성가의 저편",
            subtitle: "잠긴 이름들이 다시 들리기 시작한다. 구조와 추모, 탐사와 봉인이 모두 같은 물결 위에 오른다.",
            tone: "ember",
        },
        {
            index: 3,
            startWeek: 73,
            endWeek: 96,
            title: "마지막 기도",
            subtitle: "끝내 성당을 닫을지, 열어 둘지, 혹은 다른 이름으로 남길지 정하는 마지막 물가의 계절.",
            tone: "burgundy",
        },
    ],
};

const SCENARIO_BOOKENDS: Record<string, ScenarioBookendDef[]> = {
    "frontier-vanguard": [
        {
            index: 0,
            endWeek: 20,
            closingLine: "원정은 아직 시작도 하지 않았는데, 벌써 누구를 끝까지 데려와야 하는지부터 마음에 남기게 되었다. 칼보다 먼저 이름을 적은 계절이었다.",
            nextTeaser: "이제 지도 위 선이 실제 흙과 피로가 된다. 행군은 준비보다 훨씬 오래 사람을 닳게 만들 것이다.",
        },
        {
            index: 1,
            endWeek: 48,
            closingLine: "길은 열렸지만, 그만큼 사람들의 얼굴에도 피로와 결핍이 선명하게 남기 시작했다. 여기서부터 원정은 승패보다 버팀의 모양으로 기억된다.",
            nextTeaser: "다음 장에선 전진만으로는 부족하다. 남겨 둘 자리와 함께 버틸 사람들을 정해야 한다.",
        },
        {
            index: 2,
            endWeek: 72,
            closingLine: "거점은 벽과 말뚝만으로 세워지지 않았다. 병사와 주민, 남은 사람과 먼저 쓰러진 사람들의 이름이 서로를 겨우 붙들며 여기까지 왔다.",
            nextTeaser: "이제 마지막 결착이 다가온다. 무엇을 지키고 무엇을 포기할지, 그 선택이 원정의 이름을 정하게 된다.",
        },
        {
            index: 3,
            endWeek: 96,
            closingLine: "끝내 남은 것은 승리나 화의라는 한 단어만이 아니다. 함께 버틴 시간, 끝내 돌아오지 못한 이름, 그리고 살아 돌아온 사람들이 앞으로도 오래 짊어질 계절의 무게가 이 원정의 진짜 결말이다.",
            nextTeaser: null,
        },
    ],
    "arena-crown": [
        {
            index: 0,
            endWeek: 24,
            closingLine: "처음의 모래는 아직 가벼웠지만, 그 위에 올린 이름은 이미 되돌리기 어려운 약속이 되었다. 투기장은 사람을 기억하기 시작했다.",
            nextTeaser: "이제부터는 승리만으로는 부족하다. 누구의 시선을 등에 업고 올라설지도 함께 가려진다.",
        },
        {
            index: 1,
            endWeek: 48,
            closingLine: "예선의 끝에서 남은 것은 점수표보다 얼굴이었다. 이긴 날의 태도와 진 날의 표정이 함께 다음 무대를 부른다.",
            nextTeaser: "준결부터는 검보다 명예가 더 오래 남는다. 한 번의 흔들림이 곧 이름의 흠으로 기록될 것이다.",
        },
        {
            index: 2,
            endWeek: 72,
            closingLine: "준결까지 오르며, 모래는 더 붉어지고 군중은 더 조용해졌다. 이제 사람들은 강함이 아니라 어떤 이름으로 끝까지 서는지를 본다.",
            nextTeaser: "왕관전은 단순한 결승이 아니다. 끝내 무엇을 지키며 이길지, 혹은 무엇을 포기하고도 이길지를 묻는 무대다.",
        },
        {
            index: 3,
            endWeek: 96,
            closingLine: "왕관은 머리에 얹는 순간보다 내려놓은 뒤에 더 무겁다. 마지막 모래 위에 남은 것은 승패 한 줄이 아니라, 끝까지 어떤 얼굴로 이름을 지켰는가 하는 기억이다.",
            nextTeaser: null,
        },
    ],
    "magitower-summit": [
        {
            index: 0,
            endWeek: 24,
            closingLine: "개회 회랑을 지나며, 이제는 누구와 인사했는가보다 누구 앞에서 어떤 침묵을 택했는지가 더 또렷하게 남기 시작했다.",
            nextTeaser: "다음 장에서는 문장보다 금기가 더 가까워진다. 서고의 문이 열릴수록 선택의 값도 함께 커질 것이다.",
        },
        {
            index: 1,
            endWeek: 48,
            closingLine: "봉인 서고는 지식을 준 만큼 사람의 평정을 가져갔다. 손에 남은 기록보다, 아직 장부에 쓰지 못한 이름들이 더 무거운 계절이었다.",
            nextTeaser: "이제 회의장은 지식보다 편을 묻는다. 어떤 진실이 살아남을지, 누가 그것을 대신 말할지를 정해야 한다.",
        },
        {
            index: 2,
            endWeek: 72,
            closingLine: "표결의 계절을 지나자, 논문은 더 이상 혼자 서 있지 못했다. 모든 문장은 누군가의 지지와 누군가의 불신 위에서만 겨우 버텼다.",
            nextTeaser: "마지막 장에선 답보다 책임이 더 중요해진다. 끝내 어떤 지식을 자신의 이름 아래 둘지 결정해야 한다.",
        },
        {
            index: 3,
            endWeek: 96,
            closingLine: "정상회의의 끝에 남은 것은 문서 한 장이 아니라, 누가 어떤 침묵과 어떤 문장을 끝내 자기 이름 아래 붙들었는가 하는 기록이다.",
            nextTeaser: null,
        },
    ],
    "skyrail-grandprix": [
        {
            index: 0,
            endWeek: 24,
            closingLine: "면허를 거치며, 속도는 더 이상 꿈이 아니라 몸으로 견뎌야 하는 진동이 되었다. 하늘 철로는 처음으로 이름을 기억하기 시작했다.",
            nextTeaser: "이제부터는 매 랩이 순위와 후원으로 돌아온다. 빠르다는 말이 곧 압박이 되는 계절이 열린다.",
        },
        {
            index: 1,
            endWeek: 48,
            closingLine: "예선 리그를 지나고 나니, 추월보다 흔들림이 더 오래 남았다. 순위표는 매번 바뀌었지만, 누가 무너지지 않았는지는 모두가 기억했다.",
            nextTeaser: "앞으로는 조종만으로는 버틸 수 없다. 기체와 사람, 정비와 팀이 함께 속도의 값을 치르게 된다.",
        },
        {
            index: 2,
            endWeek: 72,
            closingLine: "정비와 추월의 계절을 지나며, 이제 승부는 손끝 하나가 아니라 누가 끝까지 기체를 살려 둘 수 있느냐의 문제가 되었다.",
            nextTeaser: "그랑프리 결선이 다가온다. 가장 빠른 길과 끝까지 남는 길이 같은 철로가 아닐 수도 있다.",
        },
        {
            index: 3,
            endWeek: 96,
            closingLine: "하늘 철로 끝에 남는 것은 기록표 한 장만이 아니다. 그 끝까지 버틴 진동, 마지막 랩의 숨, 그리고 누구의 기체가 전설이 되었는지가 함께 남는다.",
            nextTeaser: null,
        },
    ],
    "sunken-cathedral": [
        {
            index: 0,
            endWeek: 24,
            closingLine: "조수의 문턱을 넘자, 성당은 더 이상 폐허가 아니었다. 잠긴 기도와 되돌아온 숨이 서로를 구분하지 못한 채 곁에 서기 시작했다.",
            nextTeaser: "다음 장에서는 더 깊이 들어가야 한다. 깊어질수록 구원과 금단의 선도 함께 흔들릴 것이다.",
        },
        {
            index: 1,
            endWeek: 48,
            closingLine: "침수 회랑을 지나며, 사람들은 자신이 물 아래를 걷고 있는지 기억 속을 걷고 있는지 점점 분간하지 못하게 되었다.",
            nextTeaser: "이제 성가의 저편이 열린다. 잠긴 이름들이 다시 들리기 시작하면, 무엇을 구조라 부를지부터 정해야 한다.",
        },
        {
            index: 2,
            endWeek: 72,
            closingLine: "성가의 저편까지 이르자, 남은 것은 탐사의 기쁨이 아니라 아직 부르지 못한 이름들의 무게였다. 물은 언제나 기억을 늦게 돌려준다.",
            nextTeaser: "마지막 기도가 다가온다. 성당을 닫을지, 열어 둘지, 혹은 다른 이름으로 남길지 여기서 끝내 정해야 한다.",
        },
        {
            index: 3,
            endWeek: 96,
            closingLine: "끝내 물 아래에 남는 것은 폐허만이 아니다. 구원이라 불린 것과 집착이라 불린 것, 그리고 끝내 닫히지 않은 기도의 흔적이 함께 남는다.",
            nextTeaser: null,
        },
    ],
};

export function getScenarioChapters(scenarioId: string): ScenarioChapterDef[] {
    return SCENARIO_CHAPTERS[scenarioId] ?? [];
}

export function getScenarioBookends(scenarioId: string): ScenarioBookendDef[] {
    return SCENARIO_BOOKENDS[scenarioId] ?? [];
}
